exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".N_2okZr7H3C17z86qQDKK{width:252px}._1QPurLuNzCpmyVENszFKyb{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;overflow:hidden;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:32px;line-height:32px;cursor:pointer}html[dir] ._1QPurLuNzCpmyVENszFKyb{padding:0 6px;background:#fff}html[dir] ._1QPurLuNzCpmyVENszFKyb:focus,html[dir] ._1QPurLuNzCpmyVENszFKyb:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}._2d1Xixp6OYBhYbGEY3uNS3{width:24px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.sK4Be6HRpXMUFrdmyOh_j{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}html[dir] .sK4Be6HRpXMUFrdmyOh_j{margin:0 4px}", ""]);

// exports
exports.locals = {
	"filtersContextMenu": "N_2okZr7H3C17z86qQDKK",
	"filterMenuItem": "_1QPurLuNzCpmyVENszFKyb",
	"checkMarkContainer": "_2d1Xixp6OYBhYbGEY3uNS3",
	"folderName": "sK4Be6HRpXMUFrdmyOh_j"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{}!./node_modules/sass-loader/lib/loader.js!./obj/mail/view/owa-mail-search-view/lib/components/FiltersContextMenu.scss
// module id = 4833
// module chunks = 37